<div>
  <app-page-breadcrumb pageTitle="Bar Chart" />
  <div class="space-y-6">

    <div>
      <app-component-card title="Bar Chart 1">
        <app-bar-chart-one/>
      </app-component-card>
    </div>

  </div>
</div>